import { useState } from 'react';
import { trustItems } from '@/mocks/homeData';

export default function TrustSafetySection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <section id="trust" className="w-full bg-background-50 py-16 md:py-24">
      <div className="container-content">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-xl">
            <p className="font-label font-medium text-label-lg text-primary-600 tracking-wide uppercase mb-3">
              Trust & Safety
            </p>
            <h2 className="font-heading text-display-md text-foreground-950 text-balance">
              Your space. Our responsibility.
            </h2>
          </div>
          <p className="text-body-lg text-foreground-600 max-w-md lg:text-right">
            Every decision we make is designed to earn — and keep — your trust from the first visit onward.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {trustItems.map((item, index) => (
            <div
              key={item.id}
              onMouseEnter={() => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(null)}
              className={`group relative p-6 md:p-7 border border-background-200/80 bg-background-50 transition-all duration-300 cursor-default ${
                activeIndex === index
                  ? 'border-primary-400 bg-primary-50/70'
                  : ''
              }`}
            >
              {/* Left accent bar */}
              <div
                className={`absolute left-0 top-0 bottom-0 w-1 transition-all duration-300 ${
                  activeIndex === index ? 'bg-primary-500' : 'bg-primary-300'
                }`}
              />

              {/* Number */}
              <span
                className={`font-heading text-display-sm leading-none transition-colors duration-300 ${
                  activeIndex === index ? 'text-primary-600' : 'text-primary-200'
                }`}
              >
                {String(index + 1).padStart(2, '0')}
              </span>

              {/* Title */}
              <h3 className="font-heading font-semibold text-heading-sm text-foreground-950 mt-4 mb-2">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-body-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}